<template>
    <div class="boxlogo">
        <!-- 品牌 logo（与登录页一致） -->
        <div class="brand">
            <img class="logo" :src="require('@/assets/images/img/logo_dt.png')" />
            <span class="brand-divider"></span>
            <div class="brand-text">
                <h1 class="brand-title">FreshMon Pulse</h1>
                <p class="brand-subtitle">ALWAYS FRESH · ALWAYS IN CONTROL</p>
            </div>
        </div>

        <!-- 八边形卡片 + 返回登录链接 -->
        <div class="register-center">
            <div class="login_in_wrap">
                <section class="login_in">
                    <h2 class="loginTitle">{{ $t('accountRedesign.register_title') }}</h2>

                    <!-- 注册类型选择器 -->
                    <div class="register-type-selector">
                        <div
                            class="type-card"
                            :class="{ active: registerType === 'personal' }"
                            @click="switchType('personal')"
                        >
                            <div class="type-head">
                                <span class="type-radio"></span>
                                <span class="type-title">{{ $t('accountRedesign.register_type_personal') }}</span>
                                <span class="type-badge">{{ $t('accountRedesign.badge_free') }}</span>
                            </div>
                            <p class="type-desc">{{ $t('accountRedesign.register_type_personal_desc') }}</p>
                        </div>
                        <div
                            class="type-card"
                            :class="{ active: registerType === 'enterprise' }"
                            @click="switchType('enterprise')"
                        >
                            <div class="type-head">
                                <span class="type-radio"></span>
                                <span class="type-title">{{ $t('accountRedesign.register_type_enterprise') }}</span>
                                <span class="type-badge need">{{ $t('accountRedesign.badge_need_company_id') }}</span>
                            </div>
                            <p class="type-desc">{{ $t('accountRedesign.register_type_enterprise_desc') }}</p>
                        </div>
                    </div>

                    <!-- 个人注册表单 -->
                    <el-form
                        v-if="registerType === 'personal'"
                        autocomplete="on"
                        :model="personalForm"
                        :rules="personalRules"
                        ref="personalForm"
                        class="register_form"
                        label-position="left"
                        @submit.native.prevent
                    >
                        <el-form-item prop="account">
                            <el-input
                                name="account"
                                type="text"
                                v-model.trim="personalForm.account"
                                autocomplete="off"
                                :placeholder="$t('accountRedesign.placeholder_username')"
                                maxlength="50"
                            >
                                <i slot="prefix" class="el-icon-user"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="username">
                            <el-input
                                name="username"
                                type="text"
                                v-model.trim="personalForm.username"
                                autocomplete="off"
                                :placeholder="$t('accountRedesign.placeholder_display_name')"
                                maxlength="80"
                            >
                                <i slot="prefix" class="el-icon-postcard"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="email">
                            <el-input
                                name="email"
                                type="text"
                                v-model.trim="personalForm.email"
                                autocomplete="off"
                                :placeholder="$t('accountRedesign.placeholder_email')"
                                maxlength="100"
                            >
                                <i slot="prefix" class="el-icon-message"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="mobile">
                            <el-input
                                name="mobile"
                                type="text"
                                v-model.trim="personalForm.mobile"
                                autocomplete="off"
                                :placeholder="$t('accountRedesign.placeholder_mobile')"
                                maxlength="20"
                            >
                                <i slot="prefix" class="el-icon-phone"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input
                                name="password"
                                maxlength="30"
                                v-model="personalForm.password"
                                show-password
                                :placeholder="$t('accountRedesign.placeholder_password_register')"
                            >
                                <i slot="prefix" class="el-icon-lock"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="confirmPassword">
                            <el-input
                                name="confirmPassword"
                                maxlength="30"
                                v-model="personalForm.confirmPassword"
                                show-password
                                :placeholder="$t('accountRedesign.placeholder_confirm_password')"
                            >
                                <i slot="prefix" class="el-icon-lock"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="captcha">
                            <div class="flexbox">
                                <el-input
                                    type="text"
                                    class="validateText"
                                    v-model.trim="personalForm.captcha"
                                    :placeholder="$t('accountRedesign.label_captcha')"
                                >
                                    <i slot="prefix" class="el-icon-key"></i>
                                </el-input>
                                <div @click="changeCode" class="voliade">
                                    <identify :identifyCode="identifyCode"></identify>
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item class="agree-item">
                            <el-checkbox v-model="personalAgreed">
                                <span class="agree-text">
                                    {{ $t('accountRedesign.agree_policy_tip') }}
                                    <template v-for="(item, index) in policyLinks">
                                        <span :key="'c' + index" v-if="index > 0" class="connector">{{ $t('accountRedesign.policy_and') }}</span>
                                        <span :key="item.key" class="policy-link" @click.stop.prevent="openPolicy(item)">{{ item.title }}</span>
                                    </template>
                                </span>
                            </el-checkbox>
                        </el-form-item>
                        <el-form-item>
                            <el-button :loading="loading" @click="handlePersonalRegister">
                                {{ $t('accountRedesign.btn_register') }}
                            </el-button>
                        </el-form-item>
                    </el-form>

                    <!-- 企业注册表单（两步流程） -->
                    <div v-if="registerType === 'enterprise'" class="enterprise-wrap">
                        <!-- 步骤指示器 -->
                        <div class="step-indicator">
                            <div class="step-item">
                                <div class="step-dot" :class="{ active: !companyVerified, done: companyVerified }">
                                    <i v-if="companyVerified" class="el-icon-check"></i>
                                    <span v-else>1</span>
                                </div>
                                <div class="step-label" :class="{ active: !companyVerified, done: companyVerified }">{{ $t('accountRedesign.step_verify_company') }}</div>
                            </div>
                            <div class="step-line" :class="{ done: companyVerified }"></div>
                            <div class="step-item">
                                <div class="step-dot" :class="{ active: companyVerified }">
                                    <span>2</span>
                                </div>
                                <div class="step-label" :class="{ active: companyVerified }">{{ $t('accountRedesign.step_userInfo') }}</div>
                            </div>
                        </div>

                        <el-form
                            autocomplete="on"
                            :model="enterpriseForm"
                            :rules="enterpriseRules"
                            ref="enterpriseForm"
                            class="register_form"
                            label-position="left"
                            @submit.native.prevent
                        >
                            <!-- 步骤 1：验证 Company ID -->
                            <el-form-item prop="companyCode">
                                <div class="company-verify-row">
                                    <el-input
                                        name="companyCode"
                                        type="text"
                                        v-model.trim="enterpriseForm.companyCode"
                                        autocomplete="off"
                                        :placeholder="$t('accountRedesign.placeholder_company_id')"
                                        :disabled="companyVerified"
                                        maxlength="30"
                                    >
                                        <i slot="prefix" class="el-icon-office-building"></i>
                                    </el-input>
                                    <el-button
                                        class="verify-btn"
                                        :loading="verifying"
                                        :disabled="companyVerified"
                                        @click="verifyCompany"
                                    >
                                        {{ companyVerified
                                            ? $t('accountRedesign.btn_verified')
                                            : (verifying
                                                ? $t('accountRedesign.btn_verifying')
                                                : $t('accountRedesign.btn_verify')) }}
                                    </el-button>
                                </div>
                            </el-form-item>

                            <!-- 验证通过提示 -->
                            <div class="company-verified-tip" v-if="companyVerified">
                                <i class="el-icon-circle-check"></i>
                                {{ $t('accountRedesign.company_verified_tip', { name: verifiedCompanyName }) }}
                            </div>

                            <!-- 申请 Company ID 链接 -->
                            <div class="apply-link" v-if="!companyVerified" @click="openApplyDialog">
                                {{ $t('accountRedesign.apply_company_link') }}
                            </div>

                            <!-- 步骤 2：用户信息表单 -->
                            <template v-if="companyVerified">
                                <el-form-item prop="account">
                                    <el-input
                                        type="text"
                                        v-model.trim="enterpriseForm.account"
                                        autocomplete="off"
                                        :placeholder="$t('accountRedesign.placeholder_username')"
                                        maxlength="50"
                                    >
                                        <i slot="prefix" class="el-icon-user"></i>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="username">
                                    <el-input
                                        type="text"
                                        v-model.trim="enterpriseForm.username"
                                        autocomplete="off"
                                        :placeholder="$t('accountRedesign.placeholder_display_name')"
                                        maxlength="80"
                                    >
                                        <i slot="prefix" class="el-icon-postcard"></i>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="email">
                                    <el-input
                                        type="text"
                                        v-model.trim="enterpriseForm.email"
                                        autocomplete="off"
                                        :placeholder="$t('accountRedesign.placeholder_email')"
                                        maxlength="100"
                                        :disabled="companyVerified"
                                    >
                                        <i slot="prefix" class="el-icon-message"></i>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="mobile">
                                    <el-input
                                        type="text"
                                        v-model.trim="enterpriseForm.mobile"
                                        autocomplete="off"
                                        :placeholder="$t('accountRedesign.placeholder_mobile')"
                                        maxlength="20"
                                        :disabled="companyVerified"
                                    >
                                        <i slot="prefix" class="el-icon-phone"></i>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="password">
                                    <el-input
                                        maxlength="30"
                                        v-model="enterpriseForm.password"
                                        show-password
                                        :placeholder="$t('accountRedesign.placeholder_password_register')"
                                    >
                                        <i slot="prefix" class="el-icon-lock"></i>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="confirmPassword">
                                    <el-input
                                        maxlength="30"
                                        v-model="enterpriseForm.confirmPassword"
                                        show-password
                                        :placeholder="$t('accountRedesign.placeholder_confirm_password')"
                                    >
                                        <i slot="prefix" class="el-icon-lock"></i>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="captcha">
                                    <div class="flexbox">
                                        <el-input
                                            type="text"
                                            class="validateText"
                                            v-model.trim="enterpriseForm.captcha"
                                            :placeholder="$t('accountRedesign.label_captcha')"
                                        >
                                            <i slot="prefix" class="el-icon-key"></i>
                                        </el-input>
                                        <div @click="changeCode" class="voliade">
                                            <identify :identifyCode="identifyCode"></identify>
                                        </div>
                                    </div>
                                </el-form-item>
                                <el-form-item class="agree-item">
                                    <el-checkbox v-model="enterpriseAgreed">
                                        <span class="agree-text">
                                            {{ $t('accountRedesign.agree_policy_tip') }}
                                            <template v-for="(item, index) in policyLinks">
                                                <span :key="'c' + index" v-if="index > 0" class="connector">{{ $t('accountRedesign.policy_and') }}</span>
                                                <span :key="item.key" class="policy-link" @click.stop.prevent="openPolicy(item)">{{ item.title }}</span>
                                            </template>
                                        </span>
                                    </el-checkbox>
                                </el-form-item>
                                <el-form-item>
                                    <el-button :loading="loading" @click="handleEnterpriseRegister">
                                        {{ $t('accountRedesign.btn_register') }}
                                    </el-button>
                                </el-form-item>
                            </template>
                        </el-form>
                    </div>

                    <!-- 底部 bar：卡片内部最末尾，语言切换（左） + 已有账号登录（右） -->
                    <div class="bottom-bar">
                        <div class="lang-switch" @click="toggleLang" :title="currentLang === 'zh_CN' ? 'Switch to English' : '切换到中文'">
                            <span class="lang-option" :class="{ active: currentLang === 'zh_CN' }">中</span>
                            <span class="lang-option" :class="{ active: currentLang === 'en_US' }">EN</span>
                            <span class="lang-slider" :class="{ 'is-en': currentLang === 'en_US' }"></span>
                        </div>
                        <span class="have-account-link" @click="goLogin">{{ $t('accountRedesign.link_have_account_signin') }}</span>
                    </div>
                </section>
                <!-- 凹槽白条 -->
                <div class="groove-strip groove-strip-left"></div>
                <div class="groove-strip groove-strip-right"></div>
            </div>
        </div>

        <!-- 底部 footer -->
        <div class="login-footer">
            <Footer></Footer>
        </div>

        <!-- 申请 Company ID 弹框 -->
        <el-dialog
            :title="$t('accountRedesign.apply_company_title')"
            :visible.sync="applyDialogVisible"
            :width="dialogWidth"
            :close-on-click-modal="false"
            append-to-body
            class="register-dialog"
        >
            <p class="apply-dialog-tip">{{ $t('accountRedesign.apply_submitted_tip') }}</p>
            <el-form
                ref="applyForm"
                :model="applyForm"
                :rules="applyRules"
                label-position="top"
                class="apply_form"
            >
                <el-form-item :label="$t('accountRedesign.label_company_name')" prop="companyName">
                    <el-input
                        type="text"
                        v-model.trim="applyForm.companyName"
                        :placeholder="$t('accountRedesign.placeholder_company_name')"
                        maxlength="200"
                    ></el-input>
                </el-form-item>
                <el-form-item :label="$t('accountRedesign.label_contact_name')" prop="contactName">
                    <el-input
                        type="text"
                        v-model.trim="applyForm.contactName"
                        :placeholder="$t('accountRedesign.placeholder_contact_name')"
                        maxlength="80"
                    ></el-input>
                </el-form-item>
                <el-form-item :label="$t('accountRedesign.label_contact_mobile')" prop="contactMobile">
                    <el-input
                        type="text"
                        v-model.trim="applyForm.contactMobile"
                        :placeholder="$t('accountRedesign.placeholder_contact_mobile')"
                        maxlength="20"
                    ></el-input>
                </el-form-item>
                <el-form-item :label="$t('accountRedesign.label_contact_email')" prop="contactEmail">
                    <el-input
                        type="text"
                        v-model.trim="applyForm.contactEmail"
                        :placeholder="$t('accountRedesign.placeholder_contact_email')"
                        maxlength="100"
                    ></el-input>
                </el-form-item>
                <el-form-item :label="$t('accountRedesign.label_description')" prop="description">
                    <el-input
                        type="textarea"
                        :autosize="{ minRows: 3, maxRows: 6 }"
                        v-model.trim="applyForm.description"
                        :placeholder="$t('accountRedesign.placeholder_description')"
                        maxlength="500"
                        show-word-limit
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="secondary-btn" @click="applyDialogVisible = false">{{ $t('accountRedesign.btn_cancel') }}</el-button>
                <el-button class="primary-btn" :loading="applyLoading" @click="submitApply">
                    {{ $t('accountRedesign.btn_ok') }}
                </el-button>
            </div>
        </el-dialog>

        <!-- 协议条款弹框 -->
        <el-dialog
            :title="policyTitle"
            :visible.sync="policyDialogVisible"
            width="60%"
            append-to-body
            class="register-dialog policy-dialog"
        >
            <iframe
                :src="policyUrl"
                width="100%"
                height="600px"
                frameborder="0"
                style="border: 1px solid #eee;"
            ></iframe>
            <div slot="footer">
                <el-button class="primary-btn" @click="policyDialogVisible = false">{{ $t('accountRedesign.btn_close') }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import identify from '../login/SIdentify'
import Footer from '../layout/Footer.vue'
import { STORAGE_PREFIX } from '@/config/storage'
import {
  registerPersonal,
  registerEnterprise,
  checkCompany,
  applyCompany
} from '@/api/modules/account.js'

// 密码策略：至少8位，必须包含大写字母 + 小写字母 + 数字 + 特殊符号
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])[a-zA-Z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,30}$/

export default {
  name: 'register',
  components: {
    identify,
    Footer
  },
  data () {
    return {
      // 注册类型：personal | enterprise
      registerType: 'personal',
      // 个人注册表单
      personalForm: {
        account: '',
        username: '',
        email: '',
        mobile: '',
        password: '',
        confirmPassword: '',
        captcha: ''
      },
      personalAgreed: false,
      // 企业注册表单（含 companyCode + 用户信息）
      enterpriseForm: {
        companyCode: '',
        account: '',
        username: '',
        email: '',
        mobile: '',
        password: '',
        confirmPassword: '',
        captcha: ''
      },
      enterpriseAgreed: false,
      // 企业 Company ID 验证状态
      companyVerified: false,
      verifiedCompanyName: '',
      verifying: false,
      // 申请 Company ID 弹框
      applyDialogVisible: false,
      applyForm: {
        companyName: '',
        contactName: '',
        contactMobile: '',
        contactEmail: '',
        description: ''
      },
      applyLoading: false,
      // 协议弹框
      policyDialogVisible: false,
      policyTitle: '',
      policyUrl: '',
      // 提交 loading
      loading: false,
      // 验证码
      identifyCode: 'm6a8',
      identifyCodes: '123456789abcdefghjkmnpqrstuvwxyz',
      // 协议链接（与 registyDia 一致）
      policyLinks: [
        {
          key: 'terms',
          url: 'https://www.vm-iot.com/user_agreement.html',
          title: this.$t('accountRedesign.policy_terms')
        },
        {
          key: 'privacy',
          url: 'https://www.vm-iot.com/privacy_policy.html',
          title: this.$t('accountRedesign.policy_privacy')
        }
      ]
    }
  },
  computed: {
    currentLang () {
      return this.$i18n && this.$i18n.locale
    },
    dialogWidth () {
      return document.documentElement && document.documentElement.clientWidth < 768 ? '92%' : '460px'
    },
    personalRules () {
      return this.buildUserRules('personal')
    },
    enterpriseRules () {
      const rules = this.buildUserRules('enterprise')
      rules.companyCode = [
        {
          required: true,
          message: this.$t('accountRedesign.placeholder_company_id'),
          trigger: 'blur'
        },
        {
          pattern: /^[0-9a-zA-Z_]{1,30}$/,
          message: this.$t('accountRedesign.label_company_id'),
          trigger: 'blur'
        }
      ]
      return rules
    },
    applyRules () {
      return {
        companyName: [
          { required: true, message: this.$t('accountRedesign.placeholder_company_name'), trigger: 'blur' }
        ],
        contactName: [
          { required: true, message: this.$t('accountRedesign.placeholder_contact_name'), trigger: 'blur' }
        ],
        contactMobile: [
          { required: true, message: this.$t('accountRedesign.placeholder_contact_mobile'), trigger: 'blur' }
        ],
        contactEmail: [
          { required: true, message: this.$t('accountRedesign.placeholder_contact_email'), trigger: 'blur' },
          { type: 'email', message: this.$t('accountRedesign.placeholder_contact_email'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 构造用户信息表单校验规则（个人 / 企业共用）
    buildUserRules (type) {
      const formData = type === 'personal' ? this.personalForm : this.enterpriseForm
      const captchaValidator = (rule, value, callback) => {
        if (!value) {
          callback(new Error(this.$t('accountRedesign.label_captcha')))
        } else if (value.toLowerCase() !== this.identifyCode.toLowerCase()) {
          callback(new Error(this.$t('accountRedesign.err_captcha_incorrect')))
        } else {
          callback()
        }
      }
      const confirmValidator = (rule, value, callback) => {
        if (!value) {
          callback(new Error(this.$t('accountRedesign.placeholder_confirm_password')))
        } else if (value !== formData.password) {
          callback(new Error(this.$t('accountRedesign.err_password_not_match')))
        } else {
          callback()
        }
      }
      return {
        account: [
          { required: true, message: this.$t('accountRedesign.label_username'), trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9_]{4,50}$/, message: this.$t('accountRedesign.placeholder_username'), trigger: 'blur' }
        ],
        username: [
          { required: true, message: this.$t('accountRedesign.label_display_name'), trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.$t('accountRedesign.label_email'), trigger: 'blur' },
          { type: 'email', message: this.$t('accountRedesign.placeholder_email'), trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: this.$t('accountRedesign.label_mobile'), trigger: 'blur' }
        ],
        password: [
          { required: true, message: this.$t('accountRedesign.label_password'), trigger: 'blur' },
          { pattern: PWD_REGEX, message: this.$t('accountRedesign.err_password_policy'), trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: this.$t('accountRedesign.label_confirm_password'), trigger: 'blur' },
          { validator: confirmValidator, trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: this.$t('accountRedesign.label_captcha'), trigger: 'blur' },
          { validator: captchaValidator, trigger: 'blur' }
        ]
      }
    },

    // 切换注册类型
    switchType (type) {
      if (this.registerType === type) return
      this.registerType = type
      // 切换后刷新验证码，避免脏数据
      this.refreshCaptcha()
      this.$nextTick(() => {
        if (this.$refs.personalForm) this.$refs.personalForm.clearValidate()
        if (this.$refs.enterpriseForm) this.$refs.enterpriseForm.clearValidate()
      })
    },

    // 验证 Company ID
    verifyCompany () {
      if (!this.enterpriseForm.companyCode) {
        this.$message.warning(this.$t('accountRedesign.placeholder_company_id'))
        return
      }
      this.verifying = true
      checkCompany(this.enterpriseForm.companyCode)
        .then(res => {
          if (res && res.state && res.state.code === 200) {
            this.companyVerified = true
            this.verifiedCompanyName = (res.result && res.result.companyName) ? res.result.companyName : (res.result || '')
            // 回填申请记录中的邮箱和手机号
            if (res.result) {
              this.enterpriseForm.email = res.result.email || ''
              this.enterpriseForm.mobile = res.result.mobile || ''
            }
            this.$message.success(
              this.$t('accountRedesign.company_verified_tip', { name: this.verifiedCompanyName })
            )
            this.$nextTick(() => {
              if (this.$refs.enterpriseForm) this.$refs.enterpriseForm.clearValidate(['companyCode', 'email', 'mobile'])
            })
          }
        })
        .catch(() => {})
        .finally(() => {
          this.verifying = false
        })
    },

    // 打开申请 Company ID 弹框
    openApplyDialog () {
      this.applyForm = {
        companyName: '',
        contactName: '',
        contactMobile: '',
        contactEmail: '',
        description: ''
      }
      this.applyDialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.applyForm) this.$refs.applyForm.clearValidate()
      })
    },

    // 提交 Company ID 申请
    submitApply () {
      this.$refs.applyForm.validate(valid => {
        if (!valid) return
        this.applyLoading = true
        const payload = {
          companyName: this.applyForm.companyName,
          contactName: this.applyForm.contactName,
          contactMobile: this.applyForm.contactMobile,
          contactEmail: this.applyForm.contactEmail,
          description: this.applyForm.description
        }
        applyCompany(payload)
          .then(res => {
            if (res && res.state && res.state.code === 200) {
              this.$message.success(this.$t('accountRedesign.success_apply_submitted'))
              this.applyDialogVisible = false
            }
          })
          .catch(() => {})
          .finally(() => {
            this.applyLoading = false
          })
      })
    },

    // 个人注册
    handlePersonalRegister () {
      this.$refs.personalForm.validate(valid => {
        if (!valid) return
        if (!this.personalAgreed) {
          this.$message.error(this.$t('accountRedesign.err_agree_policy_required'))
          return
        }
        this.loading = true
        const payload = {
          account: this.personalForm.account,
          username: this.personalForm.username,
          email: this.personalForm.email,
          mobile: this.personalForm.mobile,
          password: this.personalForm.password,
          confirmPassword: this.personalForm.confirmPassword
        }
        registerPersonal(payload)
          .then(res => {
            if (res && res.state && res.state.code === 200) {
              this.$message.success(this.$t('accountRedesign.success_register_personal'))
              this.$router.push('/login')
            } else {
              if (res && res.state && res.state.msg) {
                this.$message.error(res.state.msg)
              }
              this.refreshCaptcha()
            }
          })
          .catch((err) => {
            console.error('register personal error:', err)
            this.refreshCaptcha()
          })
          .finally(() => {
            this.loading = false
          })
      })
    },

    // 企业注册（注册即 Root）
    handleEnterpriseRegister () {
      this.$refs.enterpriseForm.validate(valid => {
        if (!valid) return
        if (!this.enterpriseAgreed) {
          this.$message.error(this.$t('accountRedesign.err_agree_policy_required'))
          return
        }
        this.loading = true
        const payload = {
          companyCode: this.enterpriseForm.companyCode,
          account: this.enterpriseForm.account,
          username: this.enterpriseForm.username,
          email: this.enterpriseForm.email,
          mobile: this.enterpriseForm.mobile,
          password: this.enterpriseForm.password,
          confirmPassword: this.enterpriseForm.confirmPassword
        }
        registerEnterprise(payload)
          .then(res => {
            if (res && res.state && res.state.code === 200) {
              this.$message.success(this.$t('accountRedesign.success_register_enterprise'))
              this.$router.push('/login')
            } else {
              if (res && res.state && res.state.msg) {
                this.$message.error(res.state.msg)
              }
              this.refreshCaptcha()
            }
          })
          .catch((err) => {
            console.error('register enterprise error:', err)
            this.refreshCaptcha()
          })
          .finally(() => {
            this.loading = false
          })
      })
    },

    // 打开协议弹框
    openPolicy (item) {
      this.policyUrl = item.url
      this.policyTitle = item.title
      this.policyDialogVisible = true
    },

    // 跳转登录页
    goLogin () {
      this.$router.push('/login')
    },

    // ===== 验证码 =====
    changeCode () {
      this.identifyCode = ''
      this.makeCode(this.identifyCodes, 4)
    },
    refreshCaptcha () {
      this.identifyCode = ''
      this.makeCode(this.identifyCodes, 4)
      // 清空已填验证码
      if (this.registerType === 'personal') {
        this.personalForm.captcha = ''
      } else {
        this.enterpriseForm.captcha = ''
      }
    },
    randomNum (min, max) {
      max = max + 1
      return Math.floor(Math.random() * (max - min) + min)
    },
    makeCode (data, len) {
      for (let i = 0; i < len; i++) {
        this.identifyCode += data[this.randomNum(0, data.length - 1)]
      }
    },

    // 中英文切换（与登录页一致）
    toggleLang () {
      const newLang = this.currentLang === 'zh_CN' ? 'en_US' : 'zh_CN'
      this.$i18n.locale = newLang
      this.$store.dispatch('app/setLanguage', newLang)
      localStorage.setItem(STORAGE_PREFIX + 'lang', newLang)
      // 同步协议链接标题
      this.policyLinks[0].title = this.$t('accountRedesign.policy_terms')
      this.policyLinks[1].title = this.$t('accountRedesign.policy_privacy')
    }
  },
  mounted () {
    this.identifyCode = ''
    this.makeCode(this.identifyCodes, 4)
  }
}
</script>

<style lang="scss" scoped>
.boxlogo {
    position: relative;
    width: 100%;
    height: 100vh;
    min-height: 600px;
    overflow: hidden;
    background: url('~@/assets/bg/bg-1.jpg') no-repeat center center;
    background-size: cover;

    .brand {
        position: absolute;
        top: 30px;
        left: 60px;
        z-index: 10;
        display: flex;
        align-items: center;
        gap: 18px;

        .logo {
            height: 72px;
            display: block;
        }

        .brand-divider {
            width: 1px;
            height: 48px;
            background: linear-gradient(to bottom, transparent 0%, rgba(48, 78, 114, 0.45) 50%, transparent 100%);
            flex-shrink: 0;
        }

        .brand-text {
            display: flex;
            flex-direction: column;
            justify-content: center;
            line-height: 1.1;
        }

        .brand-title {
            margin: 0;
            font-family: 'Source Han Sans CN', 'PingFang SC', 'Microsoft YaHei', sans-serif;
            font-size: 26px;
            font-weight: 700;
            letter-spacing: 0.5px;
            color: #1f2937;
            /* 主题色渐变标题，跟随 --primary-color 切换 */
            background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-color-hover) 60%, var(--primary-color) 100%);
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        .brand-subtitle {
            margin: 6px 0 0 0;
            font-family: 'Helvetica Neue', 'Arial', sans-serif;
            font-size: 11px;
            font-weight: 500;
            letter-spacing: 2.5px;
            color: #6b7280;
            text-transform: uppercase;
        }
    }

    .login-footer {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 10;

        ::v-deep.el-footer {
            height: 60px !important;
            background: transparent;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        ::v-deep.el-footer span {
            color: rgba(56, 56, 56, 0.85);
        }
    }

    /* 居中容器：卡片 + 底部一行 */
    .register-center {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 5;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 520px;
        max-width: calc(100vw - 40px);
    }

    .login_in_wrap {
            position: relative;
            width: 100%;

            /* 凹槽内的独立白色细条 */
            .groove-strip {
                position: absolute;
                top: 45.44%;
                width: 0.84%;
                height: 8.94%;
                background: #ffffff;
                z-index: 6;
                pointer-events: none;
            }

            .groove-strip-left {
                left: 0.21%;
            }

            .groove-strip-right {
                right: 0.21%;
            }
        }

    .login_in {
            position: relative;
            width: 100%;
            background: #ffffff;
            filter: drop-shadow(0 8px 24px rgba(48, 78, 114, 0.18)) drop-shadow(0 2px 6px rgba(0, 0, 0, 0.04));
            /* 八边形：四角斜切 + 左右中间连续梯形凹槽（与登录页完全相同） */
            clip-path: polygon(
                3.13% 0%, 96.87% 0%,
                100% 2.68%, 100% 44.36%,
                97.91% 45.26%, 97.91% 54.56%,
                100% 55.46%, 100% 97.32%,
                96.87% 100%, 3.13% 100%,
                0% 97.32%, 0% 55.46%,
                2.09% 54.56%, 2.09% 45.26%,
                0% 44.36%, 0% 2.68%
            );
            padding: 30px 40px 24px 40px;
            box-sizing: border-box;
            max-height: calc(100vh - 120px);
            overflow-y: auto;
            overflow-x: hidden;

            /* 细滚动条 */
            &::-webkit-scrollbar {
                width: 6px;
            }
            &::-webkit-scrollbar-thumb {
                background: rgba(48, 78, 114, 0.18);
                border-radius: 3px;
            }
            &::-webkit-scrollbar-track {
                background: transparent;
            }

            .loginTitle {
                text-align: center;
                font-family: 'Source Han Sans CN';
                font-size: 20px;
                font-weight: 600;
                color: #1f2937;
                margin: 0 0 18px 0;
                letter-spacing: 1px;
            }

            /* 注册类型选择器 */
            .register-type-selector {
                display: flex;
                gap: 12px;
                margin-bottom: 20px;

                .type-card {
                    flex: 1;
                    border: 1.5px solid #e8ecf1;
                    border-radius: 10px;
                    padding: 12px 10px 10px;
                    cursor: pointer;
                    background: #f5f7fa;
                    transition: all 0.2s ease;
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                    overflow: hidden;

                    &:hover {
                        border-color: #9cb4d8;
                    }

                    &.active {
                        border-color: var(--primary-color);
                        background: rgba(48, 78, 114, 0.04);
                        box-shadow: 0 0 0 3px rgba(48, 78, 114, 0.1);
                    }

                    .type-head {
                        display: flex;
                        align-items: center;
                        gap: 6px;
                    }

                    .type-radio {
                        width: 16px;
                        height: 16px;
                        border-radius: 50%;
                        border: 2px solid #c4c9d0;
                        position: relative;
                        flex-shrink: 0;
                        transition: all 0.2s ease;
                    }

                    &.active .type-radio {
                        border-color: var(--primary-color);
                        &::after {
                            content: '';
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            width: 8px;
                            height: 8px;
                            border-radius: 50%;
                            background: var(--primary-color);
                        }
                    }

                    .type-title {
                        font-size: 14px;
                        font-weight: 600;
                        color: #1f2937;
                    }

                    .type-desc {
                        margin: 2px 0 0;
                        font-size: 11px;
                        color: #9ca3af;
                        line-height: 1.45;
                    }

                    .type-badge {
                        display: inline-block;
                        font-size: 9px;
                        padding: 1px 5px;
                        border-radius: 999px;
                        background: #eef1f6;
                        color: #6b7280;
                        margin-left: auto;
                        flex-shrink: 0;
                        white-space: nowrap;

                        &.need {
                            background: rgba(48, 78, 114, 0.1);
                            color: var(--primary-color);
                        }
                    }
                }
            }

            /* 企业注册步骤指示器 */
            .step-indicator {
                display: flex;
                align-items: flex-start;
                margin-bottom: 18px;

                .step-item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    flex: 0 0 auto;
                    z-index: 2;

                    .step-dot {
                        width: 28px;
                        height: 28px;
                        border-radius: 50%;
                        background: #eef1f6;
                        color: #6b7280;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 13px;
                        font-weight: 600;
                        border: 2px solid #d5dae0;
                        transition: all 0.25s ease;

                        &.active,
                        &.done {
                            background: var(--primary-color);
                            color: #fff;
                            border-color: var(--primary-color);
                        }
                    }

                    .step-label {
                        margin-top: 6px;
                        font-size: 12px;
                        color: #6b7280;
                        white-space: nowrap;
                        padding: 2px 8px;
                        border-radius: 999px;
                        transition: all 0.25s ease;

                        &.active,
                        &.done {
                            color: #ffffff;
                            font-weight: 600;
                            background: var(--primary-color);
                        }
                    }
                }

                .step-line {
                    flex: 1;
                    height: 2px;
                    background: #e8ecf1;
                    margin: 13px 10px 0;
                    position: relative;
                    z-index: 1;
                    transition: background 0.25s ease;

                    &.done {
                        background: var(--primary-color);
                    }
                }
            }

            /* Company ID 验证行 */
            .company-verify-row {
                display: flex;
                align-items: center;
                gap: 8px;
                width: 100%;

                > .el-input {
                    flex: 1;
                    min-width: 0;
                }

                ::v-deep .el-button.verify-btn {
                    flex-shrink: 0;
                    width: auto;
                    height: 46px;
                    margin-top: 0;
                    padding: 0 20px;
                    letter-spacing: 0;
                    font-size: 13px;
                    background-color: var(--primary-color) !important;
                    border-color: var(--primary-color) !important;
                    color: #ffffff;
                    border-radius: 8px;

                    &:hover {
                        background-color: var(--primary-color-hover) !important;
                        border-color: var(--primary-color-hover) !important;
                    }

                    &.is-disabled {
                        opacity: 0.65;
                        background-color: var(--primary-color) !important;
                        border-color: var(--primary-color) !important;
                    }
                }
            }

            .company-verified-tip {
                display: flex;
                align-items: center;
                gap: 6px;
                font-size: 12px;
                color: var(--primary-color);
                background: rgba(48, 78, 114, 0.06);
                border-radius: 6px;
                padding: 8px 12px;
                margin: -6px 0 14px;

                i {
                    font-size: 15px;
                }
            }

            .apply-link {
                text-align: right;
                font-size: 12px;
                color: #9ca3af;
                cursor: pointer;
                margin: -6px 0 14px;
                user-select: none;
                transition: color 0.2s ease;

                &:hover {
                    color: var(--primary-color);
                }
            }

            /* 协议勾选 */
            .agree-item {
                margin-top: 4px !important;
                margin-bottom: 14px !important;

                ::v-deep .el-checkbox {
                    display: flex;
                    align-items: center;
                    color: #6b7280;
                }

                ::v-deep .el-checkbox__input .el-checkbox__inner {
                    height: 16px;
                    width: 16px;
                    margin-top: 2px;
                }

                ::v-deep .el-checkbox__label {
                    font-size: 12px;
                    line-height: 1.5;
                    white-space: normal;
                    word-break: break-word;
                }

                ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
                    background-color: var(--primary-color);
                    border-color: var(--primary-color);
                }

                ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
                    color: var(--primary-color);
                }

                .agree-text {
                    .connector {
                        margin: 0 2px;
                    }

                    .policy-link {
                        color: var(--primary-color);
                        cursor: pointer;
                        border-bottom: 1px solid var(--primary-color);
                        transition: all 0.2s ease;

                        &:hover {
                            color: var(--primary-color-hover);
                            border-bottom-color: var(--primary-color-hover);
                        }
                    }
                }
            }

            /* 表单：复用登录页 el-input / el-button 样式 */
            .register_form,
            .login_form {
                .el-form-item {
                    margin-bottom: 16px;
                }

                .el-input {
                    ::v-deep .el-input__inner {
                        height: 46px;
                        line-height: 46px;
                        border: 1px solid #e8ecf1;
                        border-radius: 8px;
                        background-color: #f5f7fa;
                        font-size: 14px;
                        color: #1f2937;
                        padding-left: 44px;
                        transition: all 0.2s ease;

                        &::placeholder {
                            color: #9ca3af;
                        }

                        &:focus {
                            border-color: var(--primary-color);
                            background-color: #ffffff;
                            box-shadow: 0 0 0 3px rgba(48, 78, 114, 0.12);
                        }

                        &:hover {
                            border-color: #9cb4d8;
                        }
                    }

                    ::v-deep .el-input__prefix {
                        left: 0;
                        width: 40px;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    ::v-deep .el-input__suffix {
                        height: 100%;
                        display: flex;
                        align-items: center;
                        padding-right: 8px;
                    }

                    ::v-deep .el-input__suffix-inner {
                        display: flex;
                        align-items: center;
                    }

                    ::v-deep .el-input__prefix-inner {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 100%;
                        height: 100%;
                    }

                    ::v-deep .el-icon-user,
                    ::v-deep .el-icon-lock,
                    ::v-deep .el-icon-key,
                    ::v-deep .el-icon-message,
                    ::v-deep .el-icon-phone,
                    ::v-deep .el-icon-postcard,
                    ::v-deep .el-icon-office-building,
                    ::v-deep .el-icon-view,
                    ::v-deep .iconfont {
                        font-size: 16px;
                        color: #6b7280;
                    }
                }

                .flexbox {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    width: 100%;

                    > .el-input {
                        flex: 1;
                        min-width: 0;
                    }

                    .voliade {
                        flex-shrink: 0;
                        width: 110px;
                        height: 46px;
                        cursor: pointer;
                        border-radius: 0;
                        overflow: hidden;
                        border: 1px solid #e8ecf1;
                        background-color: #f5f7fa;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        transition: all 0.2s ease;

                        &:hover {
                            border-color: var(--primary-color);
                            box-shadow: 0 0 0 3px rgba(48, 78, 114, 0.08);
                        }
                    }
                }

                ::v-deep .el-button {
                    width: 100%;
                    height: 48px;
                    margin-top: 4px;
                    background-color: var(--primary-color) !important;
                    border-color: var(--primary-color) !important;
                    border-radius: 8px;
                    font-size: 15px;
                    font-weight: 500;
                    letter-spacing: 2px;
                    color: #ffffff;
                    transition: all 0.2s ease;

                    &:hover {
                        background-color: var(--primary-color-hover) !important;
                        border-color: var(--primary-color-hover) !important;
                        box-shadow: 0 4px 12px rgba(48, 78, 114, 0.3);
                    }

                    &:active {
                        background-color: var(--primary-color) !important;
                        border-color: var(--primary-color) !important;
                    }

                    &.is-loading {
                        background-color: var(--primary-color) !important;
                    }
                }
            }
        }

    /* 卡片底部一行：语言切换（左） + 已有账号登录（右） */
    .bottom-bar {
        width: 100%;
        margin-top: 16px;
        padding-top: 14px;
        border-top: 1px solid #f0f2f5;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
    }

    .have-account-link {
        color: #344962;
        cursor: pointer;
        font-size: 13px;
        border-bottom: 1px solid #344962;
        user-select: none;
        transition: all 0.2s ease;

        &:hover {
            color: var(--primary-color);
            border-bottom-color: var(--primary-color);
        }
    }

    /* 语言切换 - 滑动式 toggle（与登录页一致 72×28 capsule） */
    .lang-switch {
        position: relative;
        display: inline-flex;
        align-items: center;
        width: 72px;
        height: 28px;
        padding: 2px;
        border-radius: 999px;
        background-color: #eef1f6;
        cursor: pointer;
        user-select: none;
        overflow: hidden;
        box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.04);
        outline: none;

        &:focus,
        &:active {
            outline: none;
        }

        .lang-option {
            position: relative;
            z-index: 2;
            flex: 1;
            text-align: center;
            font-size: 12px;
            font-weight: 500;
            line-height: 24px;
            color: #9ca3af;
            background-color: transparent;
            transition: color 0.25s ease;

            &.active {
                color: #fff;
                font-weight: 600;
                background-color: transparent;
            }
        }

        .lang-slider {
            position: absolute;
            top: 2px;
            left: 2px;
            z-index: 1;
            width: calc(50% - 2px);
            height: calc(100% - 4px);
            border-radius: 999px;
            background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-color-hover) 100%);
            box-shadow: 0 2px 6px rgba(48, 78, 114, 0.35);
            transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);

            &.is-en {
                transform: translateX(100%);
            }
        }

        &:hover .lang-slider {
            box-shadow: 0 2px 8px rgba(48, 78, 114, 0.5);
        }
    }
}

@media only screen and (max-width: 1024px) {
    .boxlogo {
        .register-center {
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 92%;
            max-width: 520px;
        }

        .brand {
            left: 20px;
            top: 18px;
            gap: 10px;

            .logo {
                height: 40px;
            }

            .brand-divider {
                height: 28px;
            }

            .brand-title {
                font-size: 16px;
            }

            .brand-subtitle {
                font-size: 9px;
                letter-spacing: 1.5px;
            }
        }
    }
}
</style>

<style lang="scss">
/* el-dialog 使用 append-to-body，DOM 移至 body，需非 scoped 全局样式 */
.register-dialog {
    .apply-dialog-tip {
        margin: 0 0 16px;
        padding: 10px 14px;
        font-size: 12px;
        line-height: 1.5;
        color: var(--primary-color);
        background: rgba(48, 78, 114, 0.06);
        border-left: 3px solid var(--primary-color);
        border-radius: 4px;
    }

    .el-dialog__header {
        padding: 18px 24px 14px;

        .el-dialog__title {
            font-size: 16px;
            font-weight: 600;
            color: #1f2937;
        }
    }

    .el-dialog__body {
        padding: 12px 24px 8px;
    }

    .el-dialog__footer {
        padding: 12px 24px 20px;
    }

    /* 申请表单输入框统一圆角与高度 */
    .apply_form {
        .el-input__inner {
            border-radius: 8px;
            border-color: #e8ecf1;

            &:focus {
                border-color: var(--primary-color);
                box-shadow: 0 0 0 3px rgba(48, 78, 114, 0.12);
            }
        }
    }

    /* 弹框底部按钮容器：增加按钮间距 */
    .dialog-footer {
        display: flex;
        justify-content: flex-end;
        gap: 16px;
    }

    /* 主题色主按钮 */
    .primary-btn {
        background-color: var(--primary-color) !important;
        border-color: var(--primary-color) !important;
        color: #ffffff !important;
        border-radius: 8px;
        min-width: 88px;
        transition: all 0.2s ease;

        &:hover {
            background-color: var(--primary-color-hover) !important;
            border-color: var(--primary-color-hover) !important;
            color: #ffffff !important;
            box-shadow: 0 4px 12px rgba(48, 78, 114, 0.3);
        }
    }

    /* 主题色次要按钮（白底主题色边框） */
    .secondary-btn {
        background-color: #ffffff !important;
        border: 1px solid var(--primary-color) !important;
        color: var(--primary-color) !important;
        border-radius: 8px;
        min-width: 88px;
        transition: all 0.2s ease;

        &:hover {
            background-color: rgba(48, 78, 114, 0.06) !important;
            color: var(--primary-color-hover) !important;
            border-color: var(--primary-color-hover) !important;
        }
    }
}
</style>
